// 카테고리 영어 → 한글 매핑
export const CATEGORY_MAPPINGS: Record<string, string> = {
  // 영어 카테고리 → 한글 카테고리
  'fashion-clothing': '패션의류',
  'fashion-accessories': '패션잡화', 
  'beauty-cosmetics': '화장품/미용',
  'food-beverage': '식품/음료',
  'home-furniture': '가구/인테리어',
  'baby-kids': '출산/육아',
  'sports-leisure': '스포츠/레저',
  'electronics-digital': '전자제품',
  'books-stationery': '도서/문구',
  'automotive': '자동차용품',
  'others': '기타',
  'health-medical': '건강/의료',
  'pet-supplies': '반려동물용품',
  'hobby-games': '취미/게임',
  'travel-outdoor': '여행/아웃도어'
};

// 한글 카테고리 → 영어 카테고리 (역방향 매핑)
export const REVERSE_CATEGORY_MAPPINGS: Record<string, string> = Object.fromEntries(
  Object.entries(CATEGORY_MAPPINGS).map(([eng, kor]) => [kor, eng])
);

// 영어 카테고리를 한글로 변환
export const translateCategoryToKorean = (englishCategory: string): string => {
  return CATEGORY_MAPPINGS[englishCategory] || englishCategory;
};

// 한글 카테고리를 영어로 변환
export const translateCategoryToEnglish = (koreanCategory: string): string => {
  if (koreanCategory === '전체') return 'all';
  return REVERSE_CATEGORY_MAPPINGS[koreanCategory] || koreanCategory;
};

// 모든 카테고리 목록 (한글 - 실제 DB에 저장된 카테고리들)
export const ALL_CATEGORIES_KOREAN = [
  '전체',
  '패션의류',
  '패션잡화', 
  '화장품/미용',
  '식품/음료',
  '가구/인테리어',
  '출산/육아',
  '스포츠/레저',
  '전자제품',
  '자동차용품',
  '건강/의료',
  '반려동물용품',
  '사무용품',
  '기타'
];